import { queryOptions } from '@tanstack/react-query';
import { notificationsEndpoints } from '@ooh/contracts';
import type { ApiClient } from '@ooh/screens';

// ─── Query key factory ────────────────────────────────────────

export const notificationKeys = {
  all: ['notifications'] as const,
  lists: () => [...notificationKeys.all, 'list'] as const,
  unreadCount: () => [...notificationKeys.all, 'unread-count'] as const,
} as const;

// ─── Query factories ──────────────────────────────────────────

/**
 * Query options for listing notifications.
 * Uses canonical queryOptions() wrapper per docs/WEB_ARCHITECTURE.md.
 */
export const listNotificationsQueryOptions = (api: Pick<ApiClient, 'call'>) =>
  queryOptions({
    queryKey: notificationKeys.lists(),
    queryFn: () => api.call(notificationsEndpoints.list, {}),
  });

/**
 * Query options for polling unread notification count.
 * Polls every 30 seconds and pauses when the document is hidden.
 * refetchIntervalInBackground: false is explicit even though it is the default
 * to make the behavior self-documenting and test-assertable.
 *
 * Traceability: spec.md:249–253 — "Polling pauses when document is hidden"
 */
export const unreadCountQueryOptions = (api: Pick<ApiClient, 'call'>) =>
  queryOptions({
    queryKey: notificationKeys.unreadCount(),
    queryFn: () => api.call(notificationsEndpoints.unreadCount, undefined),
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });
